import React from "react";
import { useServiceMenu } from "../DeviceData/useServiceMenu";
import { ServiceMenuScreen } from "./ServiceMenuScreen";
export function AdminServiceMenu(_ref) {
  var title = _ref.title,
      backTo = _ref.backTo,
      deviceScreens = _ref.deviceScreens,
      menuApi = _ref.menuApi;
  var serviceMenu = useServiceMenu();
  return /*#__PURE__*/React.createElement(ServiceMenuScreen, {
    title: title,
    serviceMenu: serviceMenu,
    backTo: backTo,
    deviceScreens: deviceScreens,
    menuApi: menuApi
  });
}